<template>
  <div class="text-message-container">
    <h1>马拉松照片广告覆盖精目标用户</h1>
    <span>借助马拉松赛事影响力，整合马拉松赛事所有资源，帮助企业挖掘商机，获得销售业绩的增长。</span>
  </div>
</template>

<script>
export default {
  name: 'TextMessageBanner'
}
</script>

<style scoped lang="stylus">
  .text-message-container
    padding: 118px 0 68px 160px
    width: 1140px
    margin: 0 auto
    h1
      font-size: 37px
      font-weight: 400
    span
      font-size: 24px
      font-weight: 500
</style>



// WEBPACK FOOTER //
// src/pages/advantage/components/TextMessageBanner.vue